// istanbul ignore file
import styled from 'styled-components';

export const StyledApp = styled.div`
    height: 100%;
    button > span.ind-action {
        font-size: 14px;
    }
`;
